import React from 'react';
import { observer } from 'mobx-react';
import { MembershipStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class MembershipCreate extends React.Component {

  onCreate = title => {
    MembershipStore.create({data: {title, membership_group_id: this.props.membershipGroupId}}, this.props.afterChange);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a title'
        onCreate={this.onCreate}
      />
    );
  }
}

export default MembershipCreate;
